import { css } from '@inter-ikea-kompis/web-component';
import PillSizeOptionsEnum from '../../enums/PillSizeOptionsEnum.js';
const BUTTON_HEIGHT = {
    small: 40,
    medium: 56
};
export default class PillStyle {
    /**
     * Returns styles.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @param options.isDisabled True if disabled.
     * @param options.icon Value of the icon prop.
     * @param options.pillSize Pill size.
     * @param options.theme Theme.
     * @param options.alignIcon ...
     * @returns Styles.
     */
    static getStyle(options) {
        const { color, spacing, border, breakpoint, motion } = options.theme;
        return css `
			:host {
				display: inline-flex;
				pointer-events: ${options.isDisabled ? 'none' : 'initial'};
			}

			.pill {
				display: flex;
				position: relative;
				min-height: ${40 / 16}rem;
				padding: 0;
				outline: none;
				border-radius: ${border.radius.radius64 / 16}rem;

				/* Disabled text selection */
				-webkit-touch-callout: none;
				-webkit-user-select: none;
				-khtml-user-select: none;
				-moz-user-select: none;
				-ms-user-select: none;
				user-select: none;
			}

			.pillButton {
				border: ${1 / 16}rem solid transparent;
				cursor: ${options.isDisabled ? 'default' : 'pointer'};
				vertical-align: middle;
				text-align: center;
				display: inline-flex;
				position: relative;
				box-sizing: border-box;
				transition-property: background, transform;
				transition-duration: ${motion.duration.medium};
				transition-timing-function: ${motion.ease.easy};
				background: ${options.isDisabled ? color.neutral.grey200 : color.neutral.grey100};
				color: ${options.isDisabled ? color.neutral.grey500 : color.neutral.grey900};
				height: ${(options.pillSize === 'small' ? BUTTON_HEIGHT.small : BUTTON_HEIGHT.medium) /
            16}rem;
				border-radius: ${border.radius.radius64 / 16}rem;
				padding: 0 ${this.getPadding(options) / 16}rem;
				user-select: none;
				-webkit-tap-highlight-color: transparent;
				justify-content: center;
				align-items: center;
				outline: none;
			}

			@media screen and (min-width: ${breakpoint.xlarge.width / 16}rem) {
				transition-duration: ${motion.duration.small};
			}

			.pillIcon {
				display: flex;
			}

			.pillSpacer {
				display: flex;
				flex-shrink: 1;
				width: ${spacing.space50 / 16}rem;
			}

			.pillText {
				display: flex;
				font-weight: bold;
			}

			.pillButtonSelected {
				transition-property: border, transform;
				transition-duration: ${motion.duration.medium};
				transition-timing-function: ${motion.ease.easy};
				border: ${1 / 16}rem solid
					${options.isDisabled ? color.neutral.grey100 : color.neutral.grey900};
			}

			.divider {
				flex-shrink: 0;
				width: ${spacing.space200 / 16}rem;
				transition-property: width;
				transition-duration: ${motion.duration.large};
				transition-timing-function: ${motion.ease.easy};
			}

			${this.getHover(options)}
			${options.isDisabled ? this.getDisabled(options) : ''}
			${this.getThumbnail(options)}
		`;
    }
    /**
     * Returns the padding.
     *
     * @param options Options.
     * @returns Styles.
     */
    static getPadding(options) {
        const { spacing } = options.theme;
        switch (options.pillSize) {
            case PillSizeOptionsEnum.small:
                return spacing.space150;
        }
        return spacing.space200;
    }
    /**
     * Returns Thumbnail.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @param options.small ...
     * @returns Css code.
     */
    static getThumbnail(options) {
        const { spacing } = options.theme;
        return css `
			.thumbnail {
				display: flex;
			}
			kompis-image {
				display: flex;
				width: ${(options.pillSize === 'small' ? spacing.space150 : spacing.space200) / 16}rem;
				height: ${(options.pillSize === 'small' ? spacing.space150 : spacing.space200) / 16}rem;
				border-radius: ${spacing.space400 / 16}rem;
				overflow: hidden;
				margin: 0 -${this.getPadding(options) / 16 / 2}rem;
			}
		`;
    }
    /**
     * Returns hover effect.
     *
     * @param options Options object.
     * @param options.theme Theme.
     * @param options.disabled ...
     * @returns Css code.
     */
    static getHover(options) {
        const { color } = options.theme;
        const inner = css `
			.pillButton:hover {
				background: ${options.isDisabled ? color.neutral.grey100 : color.neutral.grey200};
			}
			.pillButtonSelected:hover {
				background: ${options.isDisabled ? color.neutral.grey100 : color.neutral.grey200};
			}
			.pillButton:active {
				background: ${options.isDisabled ? color.neutral.grey100 : color.neutral.grey300};
			}
			.pillButtonSelected:active {
				background: ${options.isDisabled ? color.neutral.grey100 : color.neutral.grey300};
			}
		`;
        return css `
			/* Prevent hover effect on touch. */
			@media (-moz-touch-enabled: 0), (pointer: fine) {
				${inner}
			}
			/* Needed for IE11 to get an hover effect. */
			@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
				${inner}
			}
		`;
    }
    /**
     * Style for button disabled.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @param options.light Version.
     * @param options.disabled ...
     * @param options.buttonType Layout.
     * @returns Style for button disabled.
     */
    static getDisabled(options) {
        const { color } = options.theme;
        return css `
			button {
				color: ${color.disabled.default} !important;
				background: ${color.disabled.default} !important;
				pointer-events: none;
			}
			.thumbnail {
				opacity: ${options.isDisabled ? '0.5' : '1'};
			}
		`;
    }
}
//# sourceMappingURL=PillStyle.js.map